import { render } from "./thhHome.vue?vue&type=template&id=53744f90&scoped=true"
import script from "./thhHome.vue?vue&type=script&lang=js"
export * from "./thhHome.vue?vue&type=script&lang=js"

import "./thhHome.vue?vue&type=style&index=0&id=53744f90&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53744f90"]])

export default __exports__